import React, { useState } from 'react';

const sections = [
  {
    title: 'About the artwork',
    content: [
      'Our artworks are printed using high resolution digital printers, ensuring museum quality Giclée prints with rich color accuracy and fine detail.',
      'Please note: The images shown are for visual representation only. There may be slight variations between what you see on screen and the actual print due to lighting and screen display differences.',
      'Prints are delivered in a rolled format without a frame. If you require framing, feel free to contact us. Framed delivery is available in Ahmedabad—reach out for more details.',
    ],
  },
  {
    title: 'Shipping',
    content: [
      'We ship across India and worldwide. To check delivery availability, please reach out to us directly on WhatsApp.',
      'Free shipping on all orders above ₹2500.',
      'Orders are usually delivered within approximately 7-10 business days.'
    ],
  },
  {
    title: 'Cancellations & Returns',
    content: [
      'Every artwork is made to order, and we take the utmost care to ensure it reaches you in perfect condition. As a result, returns and refunds are only available in special cases (e.g., damaged or incorrect items).',
      'To cancel an order, please do so within 24 hours of placing it. After this window, the production process begins, and cancellations may no longer be possible.',
    ],
  },
];

const CollapsibleInfo = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="w-full max-w-4xl mx-auto px-4 py-6">
      {sections.map((section, index) => {
        const isOpen = openIndex === index;

        return (
          <div key={index} className="mb-4 border border-gray-300 rounded-lg overflow-hidden shadow-sm text-gray-500">
            <button
              onClick={() => toggleSection(index)}
              className="w-full flex items-center justify-between px-4 py-3 bg-gray-100 hover:bg-gray-200 text-left transition-colors duration-200 font-serif"
            >
              <span>{section.title}</span>
              <span className={`transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
                ▼
              </span>
            </button>

            <div
              className={`transition-max-height duration-500 ease-in-out overflow-hidden ${
                isOpen ? 'max-h-[1000px]' : 'max-h-0'
              } bg-white`}
            >
              <div className="px-4 py-3">
                <ul className="list-disc list-inside space-y-2 text-gray-700 text-base sm:text-base">
                  {section.content.map((line, i) => (
                    <li key={i}>{line}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CollapsibleInfo;
